/**
 * PURPOSE: Provide reducers that are not required for the initial bootstrap of the application.  For the bootstrap related reducers
 *   take a look at `initialReducers.ts`.
 */

// libraries
import { salesCheckinConfiguration } from '../activities/sales-checkin-dashboard';
import type { InitContext } from '@makemydeal/dr-shared-store';
import { bridgeUserReducer } from '@makemydeal/dr-shared-store';
import type { RemainingReducers } from '../types';
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { tradeInConfiguration } from '../activities/trade-in';
import { creditAppConfiguration } from '../activities/credit-app';
import { dealershipPickerConfiguration } from '../activities/dealership-picker';
import { roleAssumptionConfiguration } from '../activities/role-assumption';
import { dealerReducer, aiSearchVehicleReducer } from '@makemydeal/dr-sales-checkin-store';
import { vehicleDetailsConfiguration } from '../activities/vehicle-details';
import { customerVehiclesConfiguration } from '../activities/customerVehicles';
import { dealRefreshReducer } from '@makemydeal/dr-sales-checkin-store';
import { requestProposalConfiguration } from '../activities/request-proposal';
import { customerCardConfiguration } from '../activities/customer-card';

/**
 * Retrieve reducers that aren't needed for the initial bootstrap of the application.  These reducers can be conditionally included
 * based on feature toggles etc.
 * @param context object that can provide additional context such as feature toggles
 * @returns object containing reducers
 */
export const getRemainingReducers = (_context: InitContext): RemainingReducers => {
    const result: RemainingReducers = {
        // ──  (feature/Activity reducers) ──────────────────────────────────
        salesCheckin: salesCheckinConfiguration.reducers,
        selectVehicle: changeVehicleConfiguration.reducer,
        tradeInComponent: tradeInConfiguration.reducer,
        creditApp: creditAppConfiguration.reducer,
        dealer: dealerReducer,
        dealershipPicker: dealershipPickerConfiguration.reducer,
        roleAssumption: roleAssumptionConfiguration.reducer,
        vehicle: aiSearchVehicleReducer,
        vehicleDetails: vehicleDetailsConfiguration.reducer,
        customerVehicles: customerVehiclesConfiguration.reducer,
        dealRefreshModal: dealRefreshReducer,
        requestProposal: requestProposalConfiguration.reducer,
        dealProposal: requestProposalConfiguration.dealProposalReducer,
        customerCard: customerCardConfiguration.reducer,
        activitiesCustomerSpd: customerCardConfiguration.spdReducer,
        // ── OTHERS ───────────────────────────────────────────────────────────
        bridgeUser: bridgeUserReducer.reducer
    };

    return result;
};
